module.exports = __webpack_public_path__ + "img/icon-3.4da2f3a5.png";